module.exports = __webpack_public_path__ + "img/joinus_ad.40065d2e.jpg";